<template>
    <div class="py-12">
        <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div class="overflow-hidden bg-white p-6 shadow-xl sm:rounded-lg">
                <h1 class="mb-4 text-2xl font-bold">Language Test Page</h1>

                <div class="mb-4">
                    <h2 class="mb-2 text-lg font-semibold">
                        Current Language Information:
                    </h2>
                    <ul class="list-inside list-disc space-y-1">
                        <li>
                            <strong>Locale from Inertia props:</strong>
                            {{ page.props.locale }}
                        </li>
                        <li>
                            <strong>User language preference:</strong>
                            {{ user?.lang || "Not set" }}
                        </li>
                        <li>
                            <strong>HTML lang attribute:</strong> {{ htmlLang }}
                        </li>
                    </ul>
                </div>

                <div class="mb-4">
                    <h2 class="mb-2 text-lg font-semibold">
                        Translation Tests:
                    </h2>
                    <ul class="list-inside list-disc space-y-1">
                        <li>
                            <strong>Welcome:</strong> {{ $t("vue.welcome") }}
                        </li>
                        <li><strong>Cancel:</strong> {{ $t("vue.cancel") }}</li>
                        <li><strong>Save:</strong> {{ $t("vue.save") }}</li>
                        <li>
                            <strong>Dashboard:</strong>
                            {{ $t("vue.dashboard") }}
                        </li>
                    </ul>
                </div>

                <div class="mb-4">
                    <h2 class="mb-2 text-lg font-semibold">
                        Manual Language Links:
                    </h2>
                    <div class="space-x-4">
                        <a
                            href="/language/en"
                            class="text-blue-600 underline hover:text-blue-800"
                            >Switch to English</a
                        >
                        <a
                            href="/language/cs"
                            class="text-blue-600 underline hover:text-blue-800"
                            >Switch to Czech</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from "vue";
import { usePage } from "@inertiajs/vue3";

const page = usePage();
const htmlLang = ref("");

const user = computed(() => page.props.user);

onMounted(() => {
    htmlLang.value = document.documentElement.getAttribute("lang") || "Not set";
});
</script>
